module.exports = __webpack_public_path__ + "static/media/link.b7994d97.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/link.svg
// module id = 376
// module chunks = 0